var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "n3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34054",
    "data-name": "\\uD328\\uC2A4 34054",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18.125A8.125,8.125,0,1,1,18.125,10,8.125,8.125,0,0,1,10,18.125Zm1.726-8.5a2.092,2.092,0,0,0,.934-1.816,2.291,2.291,0,0,0-2.428-2.173c-1.265,0-2.485,1-2.485,1.924a.807.807,0,0,0,.741.878c.775,0,.627-1.163,1.709-1.163a.766.766,0,0,1,.821.8c0,1.318-1.619.475-1.619,1.722,0,1.4,1.938.178,1.938,1.84a1.076,1.076,0,0,1-1.072,1.1c-1.288,0-1.106-1.389-1.881-1.389a.872.872,0,0,0-.878.8,2.614,2.614,0,0,0,2.736,2.232,2.752,2.752,0,0,0,2.872-2.624A2.367,2.367,0,0,0,11.726,9.623Z",
    transform: "translate(0 0)",
    fill: "#2389a8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN3);
export default __webpack_public_path__ + "static/media/n3.43c07e9f7a8a4b1d6780fd3433df4ac2.svg";
export { ForwardRef as ReactComponent };